export default "__VITE_ASSET__Bo2RPKh___"